// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KRPU","colBig":"styles_colBig__1lKYa","colSmall":"styles_colSmall__3I3uX","shopifyNameWrapper":"styles_shopifyNameWrapper__3Qe3M"};